@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.container {
  @include cxy.stack(var(--cxy-spacing-xsm));
}

.rangeSliderFilter {
  margin-top: var(--cxy-spacing-xsm);
}

.resetButton {
  align-self: center;
}
